import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

const DashboardDefault = Loadable(lazy(() => import('pages_i/dashboard/default')));
const Clientes = Loadable(lazy(() => import('pages_i/clientes')));
const ClienteDetalle = Loadable(lazy(() => import('pages_i/clientes/detalle')));
const NuevoCliente = Loadable(lazy(() => import('pages_i/clientes/nuevo')));
const EditarCliente = Loadable(lazy(() => import('pages_i/clientes/editar')));
const Oportunidades = Loadable(lazy(() => import('pages_i/oportunidades')));
const NuevoOportunidad = Loadable(lazy(() => import('pages_i/oportunidades/nuevo')));
const OportunidadDetalle = Loadable(lazy(() => import('pages_i/oportunidades/detalle')));
const PendienteBoletin = Loadable(lazy(() => import('pages_i/pendiente-boletin')));
const Visitas = Loadable(lazy(() => import('pages_i/visitas')));
const PresupuestosOportunidades = Loadable(lazy(() => import('pages_i/presupuestos')));
const VisitaDetalle = Loadable(lazy(() => import('pages_i/visitas/detalle')));
const StartVisitWizard = Loadable(lazy(() => import('pages_i/visitas/StartVisitWizard')));
const Instalaciones = Loadable(lazy(() => import('pages_i/instalaciones')));
const InstalacionDetalle = Loadable(lazy(() => import('pages_i/instalaciones/detalle')));
const FinalizarInstalacion = Loadable(lazy(() => import('pages_i/instalaciones/finalizar')));
const Terminados = Loadable(lazy(() => import('pages_i/terminados')));
const Rechazadas = Loadable(lazy(() => import('pages_i/rechazadas')));
const Year2025 = Loadable(lazy(() => import('pages_i/2025')));

import { useAuth } from 'contexts/AuthContext';

const LEGACY_ROLE_MAP = {
  admin: 'admin',
  of_tecnica: 'admin',
  responsable_c: 'supervisor',
  responsable_e: 'supervisor',
  responsable_p: 'supervisor',
  operario_c: 'operario',
  operario_e: 'operario',
  operario_p: 'operario',
  user: 'operario',
  demo: 'operario',
  contabilidad: 'contabilidad',
  comercial: 'comercial'
};

const normalizeRole = (role) => {
  if (!role) return '';
  const key = String(role).trim().toLowerCase();
  return LEGACY_ROLE_MAP[key] || key;
};

const OperarioRedirect = ({ children }) => {
  const { user } = useAuth();
  const isOperario = normalizeRole(user?.role) === 'operario';
  if (isOperario) {
    return <Navigate to="/i/dashboard/instalaciones" replace />;
  }
  return children;
};

// ==============================|| IBERDROLA ROUTING ||============================== //

const IberdrolaRoutes = {
  path: '/i',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    { path: '', element: <Navigate to="/i/dashboard/default" replace /> },
    {
      path: 'dashboard',
      children: [
        { path: 'default', element: <DashboardDefault /> },
        { path: 'clientes', element: <Clientes /> },
  { path: 'clientes/nuevo', element: <NuevoCliente /> },
  { path: 'clientes/editar/:id', element: <EditarCliente /> },
        { path: 'clientes/:id', element: <ClienteDetalle /> },
        {
          path: 'oportunidades',
          element: (
            <OperarioRedirect>
              <Oportunidades />
            </OperarioRedirect>
          )
        },
  {
          path: 'oportunidades/nuevo',
          element: (
            <OperarioRedirect>
              <NuevoOportunidad />
            </OperarioRedirect>
          )
        },
        {
          path: 'oportunidades/:id',
          element: (
            <OperarioRedirect>
              <OportunidadDetalle />
            </OperarioRedirect>
          )
        },
        {
          path: 'presupuestos',
          element: (
            <OperarioRedirect>
              <PresupuestosOportunidades />
            </OperarioRedirect>
          )
        },
        {
          path: 'visitas',
          element: (
            <OperarioRedirect>
              <Visitas />
            </OperarioRedirect>
          )
        },
        {
          path: 'visitas/:id',
          element: (
            <OperarioRedirect>
              <VisitaDetalle />
            </OperarioRedirect>
          )
        },
        {
          path: 'visitas/:id/iniciar',
          element: (
            <OperarioRedirect>
              <StartVisitWizard />
            </OperarioRedirect>
          )
        },
        { path: 'instalaciones', element: <Instalaciones /> },
        { path: 'instalaciones/:id', element: <InstalacionDetalle /> },
        { path: 'instalaciones/:id/finalizar', element: <FinalizarInstalacion /> },
        {
          path: 'pendiente-boletin',
          element: (
            <OperarioRedirect>
              <PendienteBoletin />
            </OperarioRedirect>
          )
        },
        {
          path: 'terminados',
          element: (
            <OperarioRedirect>
              <Terminados />
            </OperarioRedirect>
          )
        },
        {
          path: 'rechazadas',
          element: (
            <OperarioRedirect>
              <Rechazadas />
            </OperarioRedirect>
          )
        },
        { path: '2025', element: <Year2025 /> }
      ]
    }
  ]
};

export default IberdrolaRoutes;
